import { More } from "@/shared/actions/more";
import { AddAttributeButton } from "./add-attribute-button";
import { SaveGroup } from "./save-group";
import { DeleteGroupButton } from "./delete-group-button";

export function Options() {
  return (
    <More
      menu={{
        items: [
          {
            key: "add attribute",
            label: <AddAttributeButton />,
          },
          {
            key: "save group",
            label: <SaveGroup />,
          },
          {
            key: "delete group",
            label: <DeleteGroupButton />,
          },
        ],
      }}
    />
  );
}
